import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const GuestsIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d='m20.73,17.27c-0.7,-0.7 -1.51,-1.28 -2.42,-1.68c1.26,-1.03 2.07,-2.59 2.07,-4.34c0,-3.09 -2.57,-5.62 -5.66,-5.57c-3.04,0.05 -5.49,2.53 -5.49,5.57c0,1.75 0.81,3.31 2.07,4.34c-0.9,0.41 -1.72,0.98 -2.42,1.68c-1.51,1.51 -2.37,3.53 -2.43,5.68c0,0.03 0,0.06 0.02,0.08c0.02,0.03 0.03,0.06 0.05,0.08c0.02,0.03 0.05,0.05 0.08,0.05c0.03,0.02 0.05,0.02 0.08,0.02l1.56,0c0.12,0 0.22,-0.09 0.23,-0.2c0.05,-1.62 0.7,-3.14 1.86,-4.27c0.58,-0.59 1.28,-1.06 2.06,-1.39c0.76,-0.31 1.59,-0.48 2.43,-0.48c1.68,0 3.29,0.67 4.49,1.87c1.14,1.14 1.79,2.65 1.86,4.27c0,0.11 0.09,0.2 0.22,0.2l1.56,0c0.03,0 0.06,0 0.09,-0.02c0.02,0 0.05,-0.02 0.06,-0.05c0.03,-0.02 0.05,-0.05 0.05,-0.08c0.02,-0.02 0.03,-0.05 0.02,-0.08c-0.05,-2.15 -0.9,-4.17 -2.43,-5.68zm-5.91,-2.45c-0.95,0 -1.86,-0.37 -2.53,-1.05c-0.33,-0.34 -0.61,-0.73 -0.78,-1.17c-0.19,-0.45 -0.27,-0.92 -0.27,-1.39c0.02,-0.92 0.37,-1.79 1.01,-2.45c0.67,-0.69 1.56,-1.08 2.51,-1.08c0.95,-0.02 1.87,0.36 2.54,1.01c0.69,0.67 1.06,1.58 1.06,2.54c0,0.95 -0.36,1.86 -1.03,2.53c-0.34,0.33 -0.73,0.59 -1.17,0.76c-0.42,0.19 -0.89,0.28 -1.36,0.28zm-6.99,-2.84c-0.02,-0.23 -0.03,-0.48 -0.03,-0.73c0,-0.44 0.05,-0.87 0.12,-1.29c0.02,-0.09 -0.05,-0.2 -0.12,-0.25c-0.39,-0.16 -0.73,-0.39 -1.03,-0.69c-0.36,-0.34 -0.64,-0.76 -0.83,-1.22c-0.19,-0.47 -0.27,-0.95 -0.25,-1.45c0.02,-0.89 0.37,-1.75 1,-2.39c0.7,-0.7 1.62,-1.08 2.61,-1.08c0.89,0.02 1.75,0.36 2.39,0.97c0.23,0.2 0.42,0.44 0.58,0.67c0.05,0.09 0.16,0.12 0.25,0.09c0.5,-0.17 1.01,-0.3 1.54,-0.34c0.16,-0.02 0.25,-0.19 0.17,-0.33c-0.9,-1.79 -2.75,-3.03 -4.88,-3.06c-3.09,-0.05 -5.66,2.48 -5.66,5.57c0,1.75 0.8,3.31 2.06,4.34c-0.89,0.41 -1.7,0.97 -2.4,1.67c-1.53,1.53 -2.4,3.54 -2.45,5.69c0,0.03 0,0.05 0.02,0.08c0.02,0.03 0.03,0.06 0.05,0.08c0.02,0.02 0.05,0.03 0.08,0.05c0.02,0.02 0.05,0.02 0.08,0.02l1.56,0c0.12,0 0.22,-0.09 0.23,-0.2c0.05,-1.62 0.7,-3.14 1.86,-4.29c0.81,-0.81 1.83,-1.37 2.92,-1.65c0.11,-0.03 0.17,-0.14 0.16,-0.25z'
        fill='#B73933'
      />
    </SvgIcon>
  )
}

export const DateIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        clipRule='evenodd'
        d='m7.46,0.33c0.47,0 0.85,0.38 0.85,0.85l0,0.5l7.76,0l0,-0.5c0,-0.47 0.38,-0.85 0.85,-0.85c0.46,0 0.84,0.38 0.84,0.85l0,0.5l0.5,0c2.7,0 4.91,2.2 4.91,4.89l0,12.15c0,2.7 -2.2,4.91 -4.91,4.91l-12.15,0c-2.7,0 -4.89,-2.2 -4.89,-4.91l0,-12.15c0,-2.69 2.19,-4.89 4.89,-4.89l0.52,0l0,-0.5c0,-0.47 0.38,-0.85 0.84,-0.85zm8.61,3.04l0,0.52c0,0.46 0.38,0.84 0.85,0.84c0.46,0 0.84,-0.38 0.84,-0.84l0,-0.52l0.5,0c1.78,0 3.22,1.44 3.22,3.21l0,1.02l-18.58,0l0,-1.02c0,-1.76 1.44,-3.21 3.21,-3.21l0.52,0l0,0.52c0,0.46 0.38,0.84 0.84,0.84c0.47,0 0.85,-0.38 0.85,-0.84l0,-0.52l7.76,0zm-13.17,5.91l0,9.45c0,1.78 1.44,3.22 3.21,3.22l12.15,0c1.78,0 3.22,-1.44 3.22,-3.22l0,-9.45l-18.58,0z'
        fill='#AF231C'
        fillRule='evenodd'
      />
    </SvgIcon>
  )
}

export const PlusIcon = (): JSX.Element => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.53558 1.57227H7.46415C7.36891 1.57227 7.32129 1.61988 7.32129 1.71512V7.32227H2.00028C1.90504 7.32227 1.85742 7.36988 1.85742 7.46512V8.53655C1.85742 8.63179 1.90504 8.67941 2.00028 8.67941H7.32129V14.2866C7.32129 14.3818 7.36891 14.4294 7.46415 14.4294H8.53558C8.63081 14.4294 8.67843 14.3818 8.67843 14.2866V8.67941H14.0003C14.0955 8.67941 14.1431 8.63179 14.1431 8.53655V7.46512C14.1431 7.36988 14.0955 7.32227 14.0003 7.32227H8.67843V1.71512C8.67843 1.61988 8.63081 1.57227 8.53558 1.57227Z'
        fill='#1270B8'
      />
    </svg>
  )
}

export const MinusIcon = (): JSX.Element => {
  return (
    <svg
      width='10'
      height='16'
      viewBox='0 0 10 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.01782 7.32227H0.982108C0.933001 7.32227 0.892822 7.38655 0.892822 7.46512V8.53655C0.892822 8.61513 0.933001 8.67941 0.982108 8.67941H9.01782C9.06693 8.67941 9.10711 8.61513 9.10711 8.53655V7.46512C9.10711 7.38655 9.06693 7.32227 9.01782 7.32227Z'
        fill='#1270B8'
      />
    </svg>
  )
}
